export default function parseTitleCase(s: string): string {
  let str = s;
  if (str.indexOf('_') !== -1) {
    str = str.split('_').join(' ');
  }
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
